import { createFileRoute } from "@tanstack/react-router";
import AdminEmailAuditDetailPage from "@/admin/pages/email-audit-detail";

export const Route = createFileRoute("/admin/email-audit/$id")({
  component: AdminEmailAuditDetailPage,
});
